import { useLayoutEffect, useRef } from 'react';

// ODSU's table header sets the column widths on each owc-table-group as inline CSS variables, and
// only redoes it when the header itself changes or resizes. Rows that virtualization mounts later
// never get them, so they lay out on a fallback grid: text shifted left, numeric columns gone.
// Reapplying the last values the header published keeps those rows aligned.
const GROUP_GRID_PROPERTIES = ['--body-grid-template-columns', '--slot-header-grid-template-columns'];

export const useGroupGridTemplate = (tableBodyRef: React.RefObject<HTMLElement | null>) => {
    const lastPublished = useRef<Record<string, string>>({});

    // Layout effect so the row is corrected in the same frame it is mounted, with no visible flash.
    useLayoutEffect(() => {
        const groups = tableBodyRef.current?.querySelectorAll<HTMLElement>('owc-table-group');
        if (!groups?.length) {
            return;
        }

        // remember what the header has already published
        groups.forEach((group) =>
            GROUP_GRID_PROPERTIES.forEach((property) => {
                const value = group.style.getPropertyValue(property);
                if (value) {
                    lastPublished.current[property] = value;
                }
            })
        );

        // and hand it to the rows that arrived without it
        groups.forEach((group) =>
            GROUP_GRID_PROPERTIES.forEach((property) => {
                const published = lastPublished.current[property];
                if (published && !group.style.getPropertyValue(property)) {
                    group.style.setProperty(property, published);
                }
            })
        );
    });
};
